/* global Autodesk, THREE */ // eslint-disable-line
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { updateMarkupState } from "../../helpers/actions/Action";

const Markups = () => {
  const markupExtension = useSelector(
    (state) => state.markupStateReducer.markupExtension
  );
  const markupState = useSelector(
    (state) => state.markupStateReducer.markupState
  );

  const markupFontSize = useSelector(
    (state) => state.markupStateReducer.markupFontSize
  );
  const markupStrokeWidth = useSelector(
    (state) => state.markupStateReducer.markupStrokeWidth
  );
  const markupFontFamily = useSelector(
    (state) => state.markupStateReducer.markupFontFamily
  );
  const markupColour = useSelector(
    (state) => state.markupStateReducer.markupColour
  );
  const selectedItem = useSelector(
    (state) => state.getSelectedModelReducer.data
  );

  const dispatch = useDispatch();

  useEffect(() => {
    switch (markupState) {
      case "open":
        enterOpenMode();
        break;
      case "text":
        enterTextEditMode();
        break;
      case "rect":
        enterRectangleEditMode();
        break;
      case "circ":
        enterCircleEditMode();
        break;
      case "poly":
        enterPolyEditMode();
        break;
      case "free":
        enterFreeEditMode();
        break;
      case "cloud":
        enterCloudEditMode();
        break;
      case "arrow":
        enterArrowEditMode();
        break;
      case "exit":
        exitEditMode();
        break;
      case "save":
        save();
        break;
      default:
    }
  }, [markupState]);

  const setMarkupSettings = () => {
    if (Autodesk?.Viewing?.Extensions?.Markups?.Core?.Utils && selectedItem!=null && (markupState !== "" && markupState!="exit")) {
      var styleAttributes = [
        "font-family",
        "font-size",
        "stroke-color",
        "stroke-width",
        "stroke-opacity",
      ];
      var nsu = Autodesk.Viewing.Extensions.Markups.Core.Utils;
      var styleObject = nsu.createStyle(styleAttributes, markupExtension);
      console.log("markupFontFamily - ", markupFontFamily);
      styleObject["font-family"] = markupFontFamily;
      styleObject["font-size"] = markupFontSize * 10;
      styleObject["stroke-color"] = markupColour;
      styleObject["stroke-width"] = markupStrokeWidth;
      markupExtension.setStyle(styleObject);
      console.log("Markup Settings Updated");
    }
  };

  useEffect(() => {
    setMarkupSettings()
  }, [markupFontSize, markupStrokeWidth, markupFontFamily, markupColour]);

  const enterOpenMode = () => {
    console.log("Open");
  };

  const save = () => {
    console.log("Saved");
  };

  const leaveEditMode = () => {
    console.log("leaveEditMode");
  };

  const hide = () => {
    console.log("hide");
  };

  const enterEditMode = () => {
    markupExtension.enterEditMode();
  };

  const exitEditMode = () => {
    if (
      window.confirm(
        "Are you sure you want to exit? All unsaved markups will be lost"
      ) == true
    ) {
      debugger;
      dispatch(updateMarkupState(""));
      markupExtension.leaveEditMode();
      markupExtension.hide();
    } else {
      dispatch(updateMarkupState("rect"));
    }
  };

  const enterTextEditMode = async () => {
    await enterEditMode();
    let text = new Autodesk.Viewing.Extensions.Markups.Core.EditModeText(
      markupExtension
    );
    //  let text =  new Autodesk.Viewing.Extensions.Markups.Core.EditModeText(markupExtension,2333,
    //    {x:10,y:10}, {x:100,y:100},'My Test String Small', {"font-size":20})

    markupExtension.changeEditMode(text);
    setMarkupSettings();
  };

  const enterRectangleEditMode = async () => {
    await enterEditMode();
    let rectangle =
      new Autodesk.Viewing.Extensions.Markups.Core.EditModeRectangle(
        markupExtension
      );
    markupExtension.changeEditMode(rectangle);
    setMarkupSettings();

  };

  const enterCircleEditMode = async () => {
    await enterEditMode();
    let circle = new Autodesk.Viewing.Extensions.Markups.Core.EditModeCircle(
      markupExtension
    );
    markupExtension.changeEditMode(circle);
    setMarkupSettings();

  };

  const enterPolyEditMode = async () => {
    await enterEditMode();
    let poly = new Autodesk.Viewing.Extensions.Markups.Core.EditModePolyline(
      markupExtension
    );
    markupExtension.changeEditMode(poly);
    setMarkupSettings();

  };

  const enterFreeEditMode = async () => {
    await enterEditMode();
    let free = new Autodesk.Viewing.Extensions.Markups.Core.EditModeFreehand(
      markupExtension
    );
    markupExtension.changeEditMode(free);
    setMarkupSettings();

  };

  const enterCloudEditMode = async () => {
    await enterEditMode();
    let cloud = new Autodesk.Viewing.Extensions.Markups.Core.EditModeCloud(
      markupExtension
    );
    markupExtension.changeEditMode(cloud);
    setMarkupSettings();

  };

  const enterArrowEditMode = async () => {
    await enterEditMode();
    let arrow = new Autodesk.Viewing.Extensions.Markups.Core.EditModeArrow(
      markupExtension
    );
    markupExtension.changeEditMode(arrow);
    setMarkupSettings();

  };

  return <></>;
};

export default Markups;
